/**
 * Logger utility that only logs in development environment
 * Prevents console logs from appearing in production builds
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugEnabled = process.env.REACT_APP_DEBUG === 'true';

// Color codes for different log levels (browser console)
const logStyles = {
  log: 'color: #2563eb',
  info: 'color: #0891b2',
  warn: 'color: #d97706',
  error: 'color: #dc2626',
  debug: 'color: #7c3aed',
  success: 'color: #16a34a',
};

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  info: (...args) => {
    if (isDevelopment) {
      console.info('%c[INFO]', logStyles.info, ...args);
    }
  },

  warn: (...args) => {
    if (isDevelopment) {
      console.warn('%c[WARN]', logStyles.warn, ...args);
    }
  },

  error: (...args) => {
    // Errors might be useful even in production for debugging critical issues
    // You can change this to isDevelopment if you want to hide errors too
    if (isDevelopment || isDebugEnabled) {
      console.error('%c[ERROR]', logStyles.error, ...args);
    }
  },

  debug: (...args) => {
    if (isDevelopment && isDebugEnabled) {
      console.log('%c[DEBUG]', logStyles.debug, ...args);
    }
  },

  success: (...args) => {
    if (isDevelopment) {
      console.log('%c✓', logStyles.success, ...args);
    }
  },

  // Group related logs together
  group: (label) => {
    if (isDevelopment) {
      console.group(label);
    }
  },

  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },

  // Performance timing
  time: (label) => {
    if (isDevelopment) {
      console.time(label);
    }
  },

  timeEnd: (label) => {
    if (isDevelopment) {
      console.timeEnd(label);
    }
  },

  // Table for structured data
  table: (data) => {
    if (isDevelopment) {
      console.table(data);
    }
  },

  // Clear console
  clear: () => {
    if (isDevelopment) {
      console.clear();
    }
  }
};

export default logger;